// extracted by mini-css-extract-plugin
export default {"questionIcon":"questionIcon_A8Wg8","title":"title_vwBgJ","total":"total_YLLpj","desc":"desc_yqjjI","small":"small_edNgy","token":"token_gxYFo"};